import {
  call, put, select,
} from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import { selectUser, selectUserLanguage, setVideoCreds } from '../../state/user/userSlice';
import {
  selectConfig,
  selectLocalizationFormat, selectLocalizationHourFormat, selectLocalizationTimeDelimiter,
  setConfig,
} from '../../state/configs/configsSlice';

export default function* fetchVideoCreds() {
  const userObj = yield select(selectUser);

  const iotumVideoEnabled = yield select((state) => selectConfig(state, 'PORTAL_PREMIUM_VIDEO_ENABLED'));
  if (iotumVideoEnabled && iotumVideoEnabled === 'yes') {
    const domain = yield call(nsApi.v2, {
      object: 'video',
      action: 'get',
    }, `domains/${userObj.domain}`);

    let videoDomainSuspended = false;
    let iotumVideoStatus = {};
    if (domain['iotum-video-status'] !== 'active') {
      iotumVideoStatus = domain['iotum-video-status']
        ? JSON.parse(domain['iotum-video-status'] || '{}')
        : {};
    }
    if (iotumVideoStatus?.status === 'suspended') {
      videoDomainSuspended = true;
    }

    if (!domain.iotum_company_id || videoDomainSuspended) {
      yield put(setConfig({
        config_name: 'PREMIUM_VIDEO_CONFIGURED',
        config_value: false,
      }));
      return;
    }

    try {
      const iotumHost = yield call(nsApi.v2, {
        object: 'video',
        action: 'get',
      }, `domains/~/users/${userObj.userId}/video`);
      console.debug('iotum host:', iotumHost);
      if (iotumHost.error_code) {
        console.error('Invalid host:', iotumHost);
        return;
      }
      if (!iotumHost['plan-slug']) {
        console.log('Host not enabled with Video plan'); // eslint-disable-line no-console
        yield (put(setConfig({
          config_name: 'PORTAL_VIDEO',
          config_value: 'no',
        })));
        return;
      }
      yield put(setConfig({
        config_name: 'PREMIUM_VIDEO_CONFIGURED',
        config_value: true,
      }));
      yield put(setVideoCreds({
        domain: iotumHost.iotum_domain,
        hostId: iotumHost.host_id,
        login_token_public_key: iotumHost.login_token_public_key,
      }));
      const hourFormat = yield select(selectLocalizationHourFormat);
      const hmDelimiter = yield select(selectLocalizationTimeDelimiter);
      const localeFormat = yield select(selectLocalizationFormat);
      const language = yield select(selectUserLanguage);
      const userTimeFormat = {
        time_24hr: !hourFormat,
        hm_separator: hmDelimiter.match(/[a-zA-Z]/) ? `[${hmDelimiter}]` : hmDelimiter,
        md_format: localeFormat === 'DMY' ? 'D M' : 'M D',
        md_y_comma: iotumHost.time_format.md_y_comma,
      };
      if (iotumHost.time_format !== userTimeFormat) {
        yield call(nsApi.v2, {
          object: 'video',
          action: 'put',
          data: { iotum_time_format: userTimeFormat, locale: language },
        }, `domains/~/users/${userObj.userId}/video`);
      }
    } catch (e) {
      console.error(e);
      console.debug('error in fetchVideoCreds e: ', e);
    }
  }
}
